// The base currency offered when a company is created. It cannot change once the books have an
// entry (ADR 0029), so it is asked for up front and pre-selected from where the browser is.

export const START_CURRENCIES: [string, string][] = [['USD', 'US dollar'], ['ZAR', 'South African rand'], ['EUR', 'Euro'], ['GBP', 'British pound'], ['CAD', 'Canadian dollar'], ['MXN', 'Mexican peso']];

const EURO = ['AT', 'BE', 'CY', 'DE', 'EE', 'ES', 'FI', 'FR', 'GR', 'HR', 'IE', 'IT', 'LT', 'LU', 'LV', 'MT', 'NL', 'PT', 'SI', 'SK'];
const BY_REGION: Record<string, string> = { US: 'USD', ZA: 'ZAR', GB: 'GBP', CA: 'CAD', MX: 'MXN', ...Object.fromEntries(EURO.map((r) => [r, 'EUR'])) };
// The timezone wins over the language: a Mac in Johannesburg is often set to en-US.
const BY_ZONE: Record<string, string> = { 'Africa/Johannesburg': 'ZAR', 'Europe/London': 'GBP', 'America/Mexico_City': 'MXN', 'America/Toronto': 'CAD', 'America/Vancouver': 'CAD' };

/** A currency from START_CURRENCIES for this timezone and locale, else USD. */
export function guessStartCurrency(timeZone?: string, locale?: string): string {
  if (timeZone && BY_ZONE[timeZone]) return BY_ZONE[timeZone];
  const region = locale?.split(/[-_]/).find((part, i) => i > 0 && /^[A-Z]{2}$/i.test(part))?.toUpperCase();
  return (region && BY_REGION[region]) || 'USD';
}

/** The guess for this browser. */
export function browserStartCurrency(): string {
  try {
    const { timeZone, locale } = Intl.DateTimeFormat().resolvedOptions();
    return guessStartCurrency(timeZone, typeof navigator !== 'undefined' ? navigator.language || locale : locale);
  } catch {
    return 'USD';
  }
}
